import React, { useState, useEffect } from 'react';

import {
  CheckPicker,
  Stack,
  Breadcrumb,
  Divider,
  Panel,
  Container,
  SelectPicker,
  Button,
} from 'rsuite';
import globalIP from '../../../GlobelIP';
import { useLocation } from 'react-router-dom';



const AllTem = () => {
  const ip = globalIP;


  const [cata, setCata] = useState([])
  const location = useLocation();
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const encodedData = queryParams.get('data');
    if (encodedData == null) {
    } else {
      const decodedData = decodeURIComponent(encodedData);
      const parsedData: any[] = JSON.parse(decodedData);

      setCata(parsedData);
    }
  }, [location.search]);

  const csvData = cata.map((item) => {
    const { id, attributes } = item;
    const { MaterialCollection,
      ProductionDetail,
      MultipleImage,
      CoverImage,
      Packaging,
      FortyHQ,
      FortyFT,
      TwentyFT,
      Total_CBM,
      publishedAt,
      updatedAt,
      createdAt,
      BuyerSku,
      BuyerName,
      ColorName,
      cbm,
      ProductTypeCode,
      MadeBy,
      ProductDesigner,
      MOQ,
      SearchKeyword,
      ProductCost,
      HSNCode,
      ColorCode,
      FinishCode,
      ProductCode,
      CategoryCode,
      Total_CFT,
      ...restAttributes } = attributes;
    const imageUrl = `${ip}${attributes.CoverImage?.data?.attributes?.url || ''}`;
    console.log(imageUrl + 'image');
    return {
      id,
      Image: imageUrl,
      ...restAttributes,
    };

  });


  const dikha =()=>{
    console.log(csvData)
  }
  
  
 
  

  return (
    <>
      <Container className='main'>
        <Stack className="table-toolbar" justifyContent="space-between">
          <Stack direction='column' alignItems='flex-start'>
            <Stack direction='column' alignItems='flex-start' >
              <h3 className="title">Marketing</h3>
              <Breadcrumb>
                <Breadcrumb.Item href="/dashboard">Home</Breadcrumb.Item>
                <Breadcrumb.Item active>Marketing</Breadcrumb.Item>
              </Breadcrumb>
            </Stack>
            <Stack spacing={5}>
            <CheckPicker
                data={[]}
                placeholder="Collections"
                
                block
              />
              

              <SelectPicker data={[]} size="xs" appearance="default" placeholder="Added On" style={{ width: 116 }} />
              <SelectPicker data={[]} size="xs" appearance="default" placeholder="Updated On" style={{ width: 116 }} />
              
            </Stack>
          </Stack>
         
        </Stack>
        <Divider className='divide' />
        <div className="row">
          <Panel>
           
<Button onClick={dikha}> Dikhao</Button>

          </Panel> 

        </div>
       </Container>
    </>
  );
};
export default AllTem;